module.exports = __webpack_public_path__ + "static/media/  (114).a36fa855.jpg";